export default {
  name: 'Adm-newsletter'
}



// WEBPACK FOOTER //
// ./src/services/Config.js